import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResizeObserverFactory {

  public create(element: HTMLElement): Observable<{ width: number, height: number }> {
    const behaviorSubject = new Subject<{ width: number, height: number }>();
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.target === element) {
          const width = entry.contentRect.width;
          const height = entry.contentRect.height;
          if (width > 0 && height > 0) {
            behaviorSubject.next({width, height});
          }
        }
      }
    });
    resizeObserver.observe(element);
    return behaviorSubject.asObservable();
  }
}
